var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-747.000000, -1117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(530.000000, 750.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Team",
    transform: "translate(217.000000, 365.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.666667, 2.666667)",
    fill: "#8298AB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4466667,6.08666674 C11.36,6.70666673 12,7.54666672 12,8.6666667 L12,10.6666667 L14.6666667,10.6666667 L14.6666667,8.6666667 C14.6666667,7.21333339 12.2866667,6.35333341 10.4466667,6.08666674 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.33333333,
    cy: 2.66666667,
    r: 2.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333337,5.33333333 C10.8066667,5.33333333 12,4.14 12,2.66666667 C12,1.19333333 10.8066667,0 9.33333337,0 C9.02000004,0 8.72666671,0.0666666667 8.44666672,0.16 C9.00000004,0.846666667 9.33333337,1.72 9.33333337,2.66666667 C9.33333337,3.61333333 9.00000004,4.48666667 8.44666672,5.17333333 C8.72666671,5.26666667 9.02000004,5.33333333 9.33333337,5.33333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,6 C3.55333333,6 0,6.89333333 0,8.66666667 L0,10.6666667 L10.6666667,10.6666667 L10.6666667,8.66666667 C10.6666667,6.89333333 7.11333333,6 5.33333333,6 Z",
    id: "Path"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.8d0f9001.svg";
export { ForwardRef as ReactComponent };